import { useContext } from 'react';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { ToolForm } from './components';
import { toolContext } from './ToolDetailsContext';

let Tools = () => {
    let service = useContext(toolContext);

    return (
        <Container>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <ToolForm />}
        </Container>
    )
}

export default Tools;